export enum VerifyAddressInvalidReason {
  CANNOT_SHIP_TO_ADDRESS = 'CANNOT_SHIP_TO_ADDRESS',
  CANNOT_SHIP_TO_STATE = 'CANNOT_SHIP_TO_STATE',
  SHIPPO_USPS_INVALID = 'SHIPPO_USPS_INVALID',
  DUPLICATE_ADDRESS = 'DUPLICATE_ADDRESS',
}
